import { ContextAction } from '../types';
import type { ToastAction, ToastState } from './types';

export const toastInitial = { toastAlert: false };

export const toastReducer = (
  state: ToastState,
  action: ToastAction
): ToastState => {
  switch (action.type) {
    case ContextAction.setToast:
      return { ...state, toastAlert: action.payload };
    default:
      return state;
  }
};
